import { render } from "./BackupTriggerDialog.vue?vue&type=template&id=52b8061a"
import script from "./BackupTriggerDialog.vue?vue&type=script&lang=js"
export * from "./BackupTriggerDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__